import React from 'react';

export default function ProgressRow({
  variant = 'desktop', // 'desktop' | 'mobile'
  cx,
  controlText,
  currentTimeTextRef,
  progressTrackRef,
  progressFillRef,
  progressKnobRef,
  handleSeekPointerDown,
  handleSeekPointerMove,
  handleSeekPointerUpOrCancel,
  duration,
  formatTime
}) {
  return (
    <div className="w-full flex items-center gap-2">
      <span ref={currentTimeTextRef} className={cx(controlText, 'w-12 text-right')}>0:00</span>
      <div
        ref={progressTrackRef}
        className="flex-1 h-2.5 bg-white/10 rounded-full cursor-pointer relative group shadow-[inset_0_1px_0_rgba(255,255,255,0.08)]"
        onPointerDown={handleSeekPointerDown}
        onPointerMove={handleSeekPointerMove}
        onPointerUp={handleSeekPointerUpOrCancel}
        onPointerCancel={handleSeekPointerUpOrCancel}
        style={{ touchAction: 'none', minWidth: 213 }}
        data-progress-track
        data-no-toggle
      >
        <div
          ref={progressFillRef}
          className="h-full rounded-full bg-gradient-to-r from-emerald-500 via-emerald-400 to-teal-300 shadow-[0_0_18px_rgba(16,185,129,0.35)]"
          style={{ width: '0%' }}
          data-progress-fill
        />
        <div
          ref={progressKnobRef}
          className="absolute top-1/2 left-0 h-3.5 w-3.5 bg-white/90 rounded-full -translate-y-1/2 opacity-100 transition-opacity shadow-[0_6px_16px_rgba(0,0,0,0.45)] ring-2 ring-emerald-400/60"
          style={{ left: '0%', marginLeft: '-8px' }}
          data-progress-knob
        />
      </div>
      <span className={cx(controlText, 'w-12')}>{formatTime(duration)}</span>
    </div>
  );
}

